/* String Constants */
export const FIRST_NAME_LABEL = 'First Name';
export const LAST_NAME_LABEL = 'Last Name';
export const EMAIL_LABEL = 'Email Address';
export const HOUSE_ADDRESS_LABEL = 'House Address';
export const SALES_PRICE_LABEL = 'Sales Price';
export const LOAN_PAYOFF_LABEL = 'Loan Payoff';
export const REAL_ESTATE_COMMISSION_LABEL = 'Real Estate Commission';
export const ATTORNEY_DOC_PREP_FEE_LABEL = 'Attorney Doc Prep Fee';
export const PROPERTY_LOCATION_LABEL = 'Property Location';
export const EXCISE_TAX_LABEL = 'Excise Tax';
export const PROCESS_FEE_TO_COUNTY_TREASURER_LABEL =
	'Process Fee to County Treasurer';
export const TITLE_INSURANCE_LABEL = "Title Insurance (Owner's Policy)";
export const TAX_ON_TITLE_INSURANCE_LABEL = 'Tax on Title Insurance';
export const ESCROW_FEE_LABEL = "Escrow Fee (Seller's half)";
export const TAX_ON_ESCROW_FEE_LABEL = 'Tax on Escrow Fee';
export const SELLERS_CONTRIBUTION_LABEL = "Seller's Contribution";
export const OTHER1_LABEL = 'Other';
export const OTHER2_LABEL = 'Other';
export const ESTIMATED_TOTAL_COSTS_LABEL = 'Estimated Total Costs';
export const TOTAL_LOAN_PAYOFFS_LABEL = 'Total Loan Payoffs';
export const ESTIMATED_NET_PROCEEDS_LABEL = 'Estimated Net Proceeds';

export const APP_HEADER = 'Estimated Seller Net Proceeds';
export const EMAIL_BUTTON_TEXT = 'Email Results';
export const PRINT_BUTTON_TEXT = 'Print';
export const RESET_BUTTON_TEXT = 'Reset';
export const CONTINUE_BUTTON_TEXT = 'Continue';

export const MESSAGE_ERROR_HEADER = 'Something went wrong.';
export const MESSAGE_ERROR_BODY =
	'There was an error sending your results. Please check your first name, last name, and email, and then try again. If the problem persists notify Valley Title Guarantee. Thanks!';
export const MESSAGE_SUCCESS_HEADER = 'Success!';
export const MESSAGE_SUCCESS_BODY =
	'Results have been sent to the email provided. You may safely leave this page, or reset the form for more estimates.';
